import { render, staticRenderFns } from "./ChapterCatalog.vue?vue&type=template&id=13b8c1e4&scoped=true"
import script from "./ChapterCatalog.vue?vue&type=script&lang=js"
export * from "./ChapterCatalog.vue?vue&type=script&lang=js"
import style0 from "./ChapterCatalog.vue?vue&type=style&index=0&id=13b8c1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8c1e4",
  null
  
)

export default component.exports